/**
 * PDP — copiar código do cupom de primeira compra.
 */
(function () {
  async function writeClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
    } finally {
      document.body.removeChild(ta);
    }
  }

  document.addEventListener('click', (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-andrade-copy-coupon]') : null;
    if (!(btn instanceof HTMLElement)) return;

    const code = (btn.getAttribute('data-coupon-code') || btn.textContent || '').trim();
    if (!code) return;

    writeClipboard(code).then(() => {
      const wrap = btn.closest('.andrade-pdp-welcome-coupon');
      const feedback = wrap ? wrap.querySelector('[data-andrade-copy-feedback]') : null;
      if (!(feedback instanceof HTMLElement)) return;
      feedback.hidden = false;
      window.clearTimeout(btn._andradeCopyTimer);
      btn._andradeCopyTimer = window.setTimeout(() => {
        feedback.hidden = true;
      }, 2000);
    }).catch(() => {});
  });
})();
